
// Legal.js

import React from 'react';
import { Outlet } from 'react-router-dom';

import ScrollableForm from '../components/foundation/ScrollableForm';
import CenteredContentPage from '../components/foundation/CenteredContentPage';

import Footer from '../components/navigation/Footer';

const Legal = () => {

    return (
        <>
            <ScrollableForm>
                <CenteredContentPage>
                    {/* Nested legal routes (index, privacy-policy, terms-of-service)
                        render here — see App.js. */}
                    <Outlet/>
                </CenteredContentPage>

                <Footer/>
            </ScrollableForm>
        </>
    )
}

export default Legal;
